(function () {
    'use strict';
    var app = angular.module('liquidSuiteLoginApp');

    app.controller('loginCtrl', ['$scope', function ($scope) {

        var prefix = lsConfiguration.prefix; // '/liquidsuitehomologacao/web';

        var urlLoginBg = prefix + '/images/login/login-bg.jpg';
        var urlLoginTela = prefix + '/images/login/' + lsConfiguration.loginTela;

        // Public 

        // --------- Variables

        $scope.telaBg = {
            'background': 'url("' + urlLoginBg + '")',
            'background-repeat': 'no-repeat',
            'background-size': 'cover'
        };

        $scope.telaImagem = {
            'background': 'url("' + urlLoginTela + '")',
            'background-repeat': 'no-repeat'
        };


    }]);
})();